export const ACCOUNT_MODEL_BINDINGS = 'bindings';
export const ACCOUNT_MODEL_CLASSIFICATION = 'classification';

export function isBindingsStrategy(strategy) {
    return strategy?.account_model === ACCOUNT_MODEL_BINDINGS;
}

export function isLegacyStrategy(strategy) {
    return !strategy || strategy.account_model === ACCOUNT_MODEL_CLASSIFICATION;
}

export function filterLegacyStrategies(strategies) {
    return (strategies || []).filter(isLegacyStrategy);
}

export function filterBindingsStrategies(strategies) {
    return (strategies || []).filter(isBindingsStrategy);
}

export function strategyModelLabel(strategy) {
    if (isBindingsStrategy(strategy)) {
        return 'quant_platform · account bindings';
    }
    return 'algoverse · classification + client lots';
}
